import { render, staticRenderFns } from "./petit-gohan.vue?vue&type=template&id=da573bf6&"
import script from "./petit-gohan.vue?vue&type=script&lang=js&"
export * from "./petit-gohan.vue?vue&type=script&lang=js&"
import style0 from "./petit-gohan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Card: require('/home/runner/work/myody_front/myody_front/components/card/Card.vue').default})
